import React from 'react';
import PropTypes from 'prop-types';
import NodeActivityEditor from '../../NodeActivityEditor';
import SecondaryButton from '../../SecondaryButton';
import { PreviewSection } from '../styles';
import { EditorHeaderRowLeft, HeaderUserName, EditorHeaderRowRight } from '../../NodeActivityEditor/styles';

const TaskContentPreview = ({ type, previewText }) => {
  const headerTextKey = type === 'group' ? 'group_task_header' : 'app_student_editor';
  const buttonTextKey = type === 'group' ? 'app_save_complete_group' : 'app_handin';
  const editorText = type === 'group' ? i18n.__('group_task_preview_text') : previewText;

  const headerPanel = (
    <>
      <EditorHeaderRowLeft>
        <HeaderUserName>{i18n.__(headerTextKey)}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight />
    </>
  );

  const buttonPanel = <SecondaryButton disabled={true} text={i18n.__(buttonTextKey)} className={'ir-hide'} />;

  return (
    <PreviewSection>
      <NodeActivityEditor type={type} headerPanel={headerPanel} buttonPanel={buttonPanel} editorText={editorText} />
    </PreviewSection>
  );
};

export default TaskContentPreview;

TaskContentPreview.propTypes = {
  type: PropTypes.string.isRequired,
  previewText: PropTypes.string.isRequired,
};
